export function setMoverVisibility(node) {
    return window.innerWidth < node.scrollWidth;
}